import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    cell: {
        justifyContent: "center",
        alignItems: "center",
        textAlign: "center"
    },
    headerTitleContainer: {
        position: "absolute",
        right: 0,
        left: 0
    },
    headerContainer: {
        flexDirection: "row",
        alignItems: "center"
    },
    codeFieldRoot: {
        justifyContent: "space-between"
    },
    backButton: {
        alignSelf: "flex-start"
    },
    headerTitle: {
        alignSelf: "center"
    },
    container: {
        alignItems: "center",
        flex: 1
    },
    logo: {
        width: 200
    }
});
export default stylesheet;
